<template>
  <el-row>
    <el-col :span="5">
      <div style="overflow-y: scroll;">
        <div id="leftTreeId" style="height: 775px;">
          <basic-container>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
            <el-tree
              class="filter-tree"
              :props="treeProps"
              node-key="id"
              ref="leftTreeRef"
              :load="lazyLoadLeftTree"
              :filter-node-method="filterNode"
              lazy
              @node-click="nodeClick"
            >
            </el-tree>
          </basic-container>
        </div>
      </div>
    </el-col>
    <el-col :span="19">
      <basic-container id="mainContainerId">
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
          :upload-preview="uploadPreview"
          :upload-before="uploadBefore"
        >
          <template slot="menuRight">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              v-if="permission.repository_add"
              @click="openRepositoryCatalogAddDialog"
              >新增目录
            </el-button>
            <el-button
              type="warning"
              icon="el-icon-edit"
              v-if="permission.repository_edit"
              @click="openRepositoryCatalogEditDialog"
            >
              修改目录
            </el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.repository_delete"
              @click="deleteCatalog"
              >删除目录
            </el-button>
          </template>
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.repository_delete"
              @click="handleDelete"
              >删除主题
            </el-button>
          </template>
        </avue-crud>
        <el-dialog
          title="修改目录"
          :visible.sync="openRepositoryCatalogEditFlag"
          :modal-append-to-body="false"
          @close="quitRepositoryCatalogEditDialog"
        >
          <div class="el-property-dialog-div">
            <avue-form
              ref="repositoryCatalogEditFormRef"
              v-model="repositoryCatalogEditForm"
              :option="repositoryCatalogEditOption"
              @submit="repositoryCatalogEditSubmit"
            >
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitRepositoryCatalogEditDialog">返回</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
        <el-dialog
          title="新增目录"
          :visible.sync="openRepositoryCatalogAddFlag"
          :modal-append-to-body="false"
          @close="quitRepositoryCatalogAddDialog"
        >
          <div class="el-property-dialog-div">
            <avue-form
              ref="repositoryCatalogAddFormRef"
              v-model="repositoryCatalogAddForm"
              :option="repositoryCatalogAddOption"
              @submit="repositoryCatalogAddSubmit"
            >
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitRepositoryCatalogAddDialog">返回</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  lazyTree,
  saveCatalog,
  updateCatalog,
  deleteCatalog,
  getDetailById,
} from '@/api/v4ward/clientserve/repository';
import { mapGetters } from 'vuex';
import repositoryCatalogAddOption from './repository-catalog-add-option';
import repositoryCatalogEditOption from './repository-catalog-edit-option';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 100,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        menuWidth: 200,
        addBtnText: '新增主题',
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属目录',
            prop: 'parentId',
            type: 'tree',
            lazy: true,
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: '请选择所属目录',
                trigger: 'blur',
              },
            ],
            props: {
              labelText: '标题',
              label: 'nodeName',
              value: 'id',
              children: 'children',
            },
            treeLoad: function (node, resolve) {
              const id = node.level === 0 ? 0 : node.data.id;
              lazyTree(id).then((res) => {
                resolve(
                  res.data.map((item) => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },
          },
          {
            label: '所属目录',
            prop: 'nodeName',
            addDisplay: false,
            editDetail: true,
            rules: [
              {
                required: true,
                message: '请输入所属目录',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '简码',
            prop: 'code',
            search: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '标题',
            prop: 'title',
            searchSpan: 10,
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入标题',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '排序号',
            prop: 'indexNum',
            hide: true,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
              {
                required: true,
                message: '请输入排序号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '内容',
            prop: 'content',
            component: 'AvueUeditor',
            params: {
              options: {
                //普通图片上传
                action: '/api/blade-resource/oss/endpoint/put-file',
                props: {
                  res: 'data',
                  url: 'link',
                },
              },
            },
            hide: true,
            minRows: 6,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入内容',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '备注',
            type: 'textarea',
            prop: 'remark',
            span: 24,
            row: 4,
            maxlength: 300,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '附件',
            prop: 'fileUrl',
            type: 'upload',
            span: 24,
            propsHttp: {
              res: 'data',
              url: 'link',
              name: 'originalName',
            },
            tip: '只能上传不超过40MB的文件或图片',
            action: '/api/blade-resource/oss/endpoint/put-file',
            dataType: 'string',
            hide: true,
          },
        ],
      },
      treeProps: {
        //标题
        label: 'nodeName',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
        //节点数据权限
      },
      editParentId: '',
      //选中的树形节点信息
      treeTrackId: '',
      treeTrackObjectCode: '',
      filterText: '',
      leftTreeRoot: {},
      leftTreeResolve: {},
      data: [],
      repositoryCatalogEditOption: repositoryCatalogEditOption,
      repositoryCatalogAddOption: repositoryCatalogAddOption,
      openRepositoryCatalogEditFlag: false,
      openRepositoryCatalogAddFlag: false,
      repositoryCatalogEditForm: [],
      repositoryCatalogAddForm: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repository_add, false),
        viewBtn: this.vaildData(this.permission.repository_view, false),
        delBtn: this.vaildData(this.permission.repository_delete, false),
        editBtn: this.vaildData(this.permission.repository_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    uploadPreview(file, column, done) {
      done(); //默认执行打开方法
      window.open(file.url);
    },
    quitRepositoryCatalogAddDialog() {
      this.$refs.repositoryCatalogAddFormRef.resetForm();
      this.openRepositoryCatalogAddFlag = false;
    },
    quitRepositoryCatalogEditDialog() {
      this.$refs.repositoryCatalogEditFormRef.resetForm();
      this.openRepositoryCatalogEditFlag = false;
    },
    repositoryCatalogAddSubmit(from, done) {
      saveCatalog(from).then(
        () => {
          done();
          this.onLoad();
          this.reloadLeftTree();
          this.quitRepositoryCatalogAddDialog();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    repositoryCatalogEditSubmit(from, done) {
      if (!from.prentId) {
        from.prentId = this.editParentId;
      }
      updateCatalog(from).then(
        () => {
          done();
          this.onLoad();
          this.reloadLeftTree();
          this.quitRepositoryCatalogEditDialog();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    openRepositoryCatalogAddDialog() {
      lazyTree(0).then(({ data }) => {
        let tree = this.findObject(this.repositoryCatalogAddOption.group[0].column, 'parentId');
        tree.dicData = data;
      });
      this.openRepositoryCatalogAddFlag = true;
    },
    openRepositoryCatalogEditDialog() {
      if (!this.treeTrackId) {
        this.$message.error('请选择左侧目录进行修改');
        return;
      }
      getDetailById({ id: this.treeTrackId }).then(({ data }) => {
        this.repositoryCatalogEditForm = data;
      });

      this.openRepositoryCatalogEditFlag = true;
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },
    nodeClick(data) {
      console.log(data);
      this.treeTrackId = data.id;
      this.treeTrackObjectCode = data.objectCode;
      this.onLoad();
    },
    //懒加载树结构
    lazyLoadLeftTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.leftTreeRoot = node;
        this.leftTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      lazyTree(id).then(({ data }) => {
        resolve(data);
      });
    },
    //重新加载左侧树结构
    reloadLeftTree() {
      this.leftTreeRoot.childNodes = [];
      this.lazyLoadLeftTree(this.leftTreeRoot, this.leftTreeResolve);
    },
    rowSave(row, loading, done) {
      //校验附件格式拼接成字符串
      let a = '';
      if (row.fileUrl instanceof Array) {
        row.fileUrl.forEach((value, index, array) => {
          if (index == row.fileUrl.length - 1) {
            a += value.value;
          } else {
            a += value.value + ',';
          }
        });
        row.fileUrl = a;
      } else if (typeof row.fileUrl == 'string') {
      } else {
        row.fileUrl = a;
      }
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    deleteCatalog() {
      if (!this.treeTrackId) {
        this.$message.error('请选择左侧目录进行修改');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return deleteCatalog({ id: this.treeTrackId });
        })
        .then(() => {
          this.onLoad();
          this.reloadLeftTree();
          this.$message.success('操作成功!');
        });
    },
    rowUpdate(row, index, loading, done) {
      //校验附件格式拼接成字符串
      let a = '';
      if (row.fileUrl instanceof Array) {
        row.fileUrl.forEach((value, index, array) => {
          if (index == row.fileUrl.length - 1) {
            a += value.value;
          } else {
            a += value.value + ',';
          }
        });
        row.fileUrl = a;
      } else if (typeof row.fileUrl == 'string') {
      } else {
        row.fileUrl = a;
      }
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },

    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.editParentId = data.parentId;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    uploadBefore(file, done, loading) {
      const isLt40MB = file.size / 1024 < 40960;
      if (!isLt40MB) {
        this.$message.error('上传文件大小不能超过40MB!');
        loading();
        return;
      }
      if (isLt40MB) {
        done();
      }
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.treeTrackObjectCode) {
        this.query.objectCode = this.treeTrackObjectCode;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      } else {
        this.loading = false;
        this.selectionClear();
      }
    },
  },
};
</script>

<style></style>
